// React & Libraries
import React from 'react';

// Ant Design
import {
  EditFilled
} from '@ant-design/icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Constants & Helpers
import Helpers from '@Apis/helpers';

function ViewSOLeftSectionAddresses({
  props, state, updateState, quickUpdateDisable
}) {

  const {
    user, selectedSO
  } = props;

  const {
    isEstimate
  } = state;

  return (
    <div className="document-address-list">
      <div className="ant-row">
        <div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__left">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Billing Address" className="document-address__title" />
              {Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && (
                <div
                  className="view-document__input-row__address-icon"
                >
                  {quickUpdateDisable && (
                    <EditFilled
                      onClick={() => updateState({
                        selectedAddressType: 'TENANT_BILLING',
                        showAddressDrawer: true,
                      })}
                    />
                  )}
                </div>
              )}
            </div>
            {selectedSO?.billing_address_info?.address1 && <H3Text text={selectedSO.billing_address_info.address1} className="document-address__details" />}
            {selectedSO?.billing_address_info?.address1 && (
              <H3Text
                text={`${selectedSO?.billing_address_info?.city}, ${selectedSO?.billing_address_info?.state}, ${selectedSO?.billing_address_info?.postal_code}, ${selectedSO?.billing_address_info?.country}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>
        <div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__right">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Shipping Address" className="document-address__title" />
              {Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user) && (
                <div
                  className="view-document__input-row__address-icon"
                >
                  {quickUpdateDisable && (
                    <EditFilled
                      onClick={() => updateState({
                        selectedAddressType: 'TENANT_SHIPPING',
                        showAddressDrawer: true,
                      })}
                    />
                  )}
                </div>
              )}
            </div>
            {selectedSO?.shipping_address_info?.address1 && <H3Text text={selectedSO.shipping_address_info.address1} className="document-address__details" />}
            {selectedSO?.shipping_address_info?.address1 && (
              <H3Text
                text={`${selectedSO?.shipping_address_info?.city}, ${selectedSO?.shipping_address_info?.state}, ${selectedSO?.shipping_address_info?.postal_code}, ${selectedSO?.shipping_address_info?.country}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSOLeftSectionAddresses;